import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';

const comp = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        
        <Typography className={props.classes.title} variant='h6'>Benvenuto</Typography>
    </div>)
}
export const Home = withStyles(styles)(comp)